import {
	Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	Fade,
	Box,
	Modal,
	Backdrop,
	TextField,
	Dialog,
	useMediaQuery,
	Slide,
	DialogContent,
	DialogActions,
	Grid,
	IconButton,
	Checkbox,
	TableSortLabel,
	Select, MenuItem, Stack,
	CircularProgress,
	Link as MuiLink
} from '@mui/material';
import axios from 'axios';
import React, { forwardRef, useEffect, useMemo, useState, useCallback, memo } from 'react';
import { app_title, endpoint } from '../../config';
import styled from '@emotion/styled';
import { customToast } from '../../lib/toastLib';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import CloseIcon from "@mui/icons-material/Close";
import { Helmet } from 'react-helmet-async';
import CreditCardUpdateDialog from '../../components/admin/CreditCardUpdateDialog';
import { EditContent } from './CreditCards';
import { useSelector } from "react-redux";
import SpecialOffersModal from './SpecialOffersModal';
import { Link } from 'react-router-dom';

// Memoize static styles
const stickyStyle = {
	position: 'sticky',
	left: 0,
	background: '#fff',
	zIndex: 2,
	borderRight: '1px solid rgba(224, 224, 224, 1)'
};

// Memoize table headers
const tableHeaders = [
	{ label: "Name", key: "name", sortable: false },
	{ label: "Income (min)", key: "min_income", sortable: false },
	{ label: "Income (max)", key: "max_income", sortable: false },
	{ label: "Age (min)", key: "min_age", sortable: false },
	{ label: "Age (max)", key: "max_age", sortable: false },
	{ label: "Ticket Class", key: "ticket_class", sortable: false },
	{ label: "Credit Score Class", key: "credit_score_class", sortable: false },
	{ label: "Salaried", key: "salaried", sortable: false },
	{ label: "Self Employed", key: "self_employed", sortable: false },
	{ label: "Business", key: "business", sortable: false },
	{ label: "Priority", key: "priority", sortable: false },
	{ label: "Lender Status", key: "lender_status", sortable: false },
	{ label: "Special Offer", key: "special_offer", sortable: false },
];

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

// Memoized button component to reduce renders
const EditableButton = memo(({ value, onClick }) => (
	<Button style={{ color: 'unset' }} title='Click to edit' onClick={onClick}>
		{value}
	</Button>
));

// Memoized cell editor component
const EditableCell = memo(({ value, name, onBlur, onChange }) => (
	<TextField
		value={value}
		name={name}
		onBlur={onBlur}
		onChange={onChange}
		size="small"
		variant="outlined"
	/>
));

// Memoized table row component
const LenderTableRow = memo(({ lender, idx, editedIndex, setEditedIndex, handleInputChange, updateTheField, ticketClass, creditScoreClass, setSelectedLender, setSelectedLenderId, setOpen, setDeleteId }) => {
	const handleEditClick = useCallback((column) => {
		setEditedIndex({
			row: idx,
			column
		});
	}, [idx, setEditedIndex]);

	return (
		<TableRow>
			<TableCell sx={stickyStyle}>
				<MuiLink
					component={Link}
					to={`/admin/lenders/${lender.lender_id}`}
					sx={{
						color: "inherit",
						textDecoration: "none",
						"&:hover": {
							textDecoration: "underline",
						},
					}}
				>
					{lender.name}
				</MuiLink>
			</TableCell>
			<TableCell>
				{editedIndex.row === idx && editedIndex.column === 'min_income' ? (
					<EditableCell
						value={lender.min_income}
						name="min_income"
						onBlur={(e) => updateTheField(e, lender.lender_id)}
						onChange={(e) => handleInputChange(e, idx)}
					/>
				) : (
					<EditableButton
						value={lender.min_income}
						onClick={() => handleEditClick('min_income')}
					/>
				)}
			</TableCell>
			<TableCell>
				{editedIndex.row === idx && editedIndex.column === 'max_income' ? (
					<EditableCell
						value={lender.max_income}
						name="max_income"
						onBlur={(e) => updateTheField(e, lender.lender_id)}
						onChange={(e) => handleInputChange(e, idx)}
					/>
				) : (
					<EditableButton
						value={lender.max_income}
						onClick={() => handleEditClick('max_income')}
					/>
				)}
			</TableCell>
			<TableCell>
				{editedIndex.row === idx && editedIndex.column === 'min_age' ? (
					<EditableCell
						value={lender.min_age}
						name="min_age"
						onBlur={(e) => updateTheField(e, lender.lender_id)}
						onChange={(e) => handleInputChange(e, idx)}
					/>
				) : (
					<EditableButton
						value={lender.min_age}
						onClick={() => handleEditClick('min_age')}
					/>
				)}
			</TableCell>
			<TableCell>
				{editedIndex.row === idx && editedIndex.column === 'max_age' ? (
					<EditableCell
						value={lender.max_age}
						name="max_age"
						onBlur={(e) => updateTheField(e, lender.lender_id)}
						onChange={(e) => handleInputChange(e, idx)}
					/>
				) : (
					<EditableButton
						value={lender.max_age}
						onClick={() => handleEditClick('max_age')}
					/>
				)}
			</TableCell>
			<TableCell>
				<Select
					value={lender.ticket_class}
					name="ticket_class"
					onChange={(e) => {
						handleInputChange(e, idx);
						updateTheField(e, lender.lender_id);
					}}
					size="small"
					sx={{
						width: '100%'
					}}
				>
					{ticketClass && ticketClass.map((option, idx) => (
						<MenuItem key={option.id || idx} value={option.id}>
							{option.value}
						</MenuItem>
					))}
				</Select>
			</TableCell>
			<TableCell>
				<Select
					value={lender.credit_score_class}
					name="credit_score_class"
					onChange={(e) => {
						handleInputChange(e, idx);
						updateTheField(e, lender.lender_id);
					}}
					size="small"
					sx={{
						width: '100%'
					}}
				>
					{creditScoreClass && creditScoreClass.map((option, idx) => (
						<MenuItem key={option.id || idx} value={option.id}>
							{option.value}
						</MenuItem>
					))}
				</Select>
			</TableCell>
			<TableCell>
				<Checkbox
					name="salaried"
					checked={lender.salaried === 1}
					onChange={(e) => {
						handleInputChange(e, idx)
						updateTheField(e, lender.lender_id)
					}}
					size="small"
				/>
			</TableCell>
			<TableCell>
				<Checkbox
					name="self_employed"
					checked={lender.self_employed === 1}
					onChange={(e) => {
						handleInputChange(e, idx)
						updateTheField(e, lender.lender_id)
					}}
					size="small"
				/>
			</TableCell>
			<TableCell>
				<Checkbox
					name="business"
					checked={lender.business === 1}
					onChange={(e) => {
						handleInputChange(e, idx)
						updateTheField(e, lender.lender_id)
					}}
					size="small"
				/>
			</TableCell>
			<TableCell>
				{editedIndex.row === idx && editedIndex.column === 'priority' ? (
					<EditableCell
						value={lender.priority}
						name="priority"
						onBlur={(e) => updateTheField(e, lender.lender_id)}
						onChange={(e) => handleInputChange(e, idx)}
					/>
				) : (
					<EditableButton
						value={lender.priority}
						onClick={() => handleEditClick('priority')}
					/>
				)}
			</TableCell>
			<TableCell>
				<Checkbox
					name="lender_status"
					checked={lender.lender_status === 1}
					onChange={(e) => {
						handleInputChange(e, idx)
						updateTheField(e, lender.lender_id)
					}}
					size="small"
				/>
			</TableCell>
			<TableCell sx={{ minWidth: 160 }}>
				<Checkbox
					name="so_status"
					checked={lender.so_status === 1}
					onChange={(e) => {
						handleInputChange(e, idx)
						updateTheField(e, lender.lender_id);
					}}
					size="small"
				/>
				<Button size="small" onClick={() => {
					setSelectedLender(lender);
					setSelectedLenderId(lender.lender_id);
					setOpen(true)
				}}>
					Edit
				</Button>
			</TableCell>
			<TableCell>
				<Box sx={{ display: 'flex', gap: 1 }}>
					<Link to={`/admin/lenders/${lender.lender_id}`}>
						<Button
							color="primary"
							variant="contained"
							size="small"
						>
							Edit
						</Button>
					</Link>
					<Button
						color="error"
						variant="contained"
						size="small"
						onClick={() => setDeleteId(lender.lender_id)}
					>
						Delete
					</Button>
				</Box>
			</TableCell>
		</TableRow>
	);
});

export default function Lenders() {
	const { t } = useTranslation();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const [editName, setEditName] = useState(null);
	const [editRecord, setEditRecord] = useState({});

	// Fetch lender list
	const [lenders, setLenders] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	// Get data from Redux store using memoization
	const ticketClass = useSelector((state) => state.smartList.ticketClass);
	const creditScoreClass = useSelector((state) => state.smartList.creditScoreClass);

	const fetchLendersList = useCallback(() => {
		setIsLoading(true);
		axios.get(`${endpoint}/api/get-lenders-data`)
			.then(({ data }) => {
				setLenders(data);
				setIsLoading(false);
			})
			.catch((error) => {
				if (error.response) {
					customToast.error(error.response.data?.message);
				} else {
					customToast.error(error.message);
				}
				setIsLoading(false);
			})
	}, []);

	useEffect(() => {
		fetchLendersList()
	}, [fetchLendersList]);

	// Create Lender
	const [showLenderModal, setShowLenderModal] = useState(false);
	const [lenderName, setLenderName] = useState("")
	const [createLenderLoading, setCreateLenderLoading] = useState(false)


	// Optimize input change for better performance
	const handleInputChange = useCallback((e, index) => {
		const name = e.target.name;
		let value = e.target.value;

		if (["salaried", "self_employed", "business", "lender_status", "so_status"].includes(name)) {
			value = e.target.checked ? 1 : 0;
		}

		if (name === 'priority') {
			if (isNaN(Number(value)) || Number(value) < 0) return;
		}

		setLenders(prevLenders =>
			prevLenders.map((lender, i) =>
				i === index ? { ...lender, [name]: value } : lender
			)
		);
	}, []);

	const createLender = useCallback((e) => {
		e.preventDefault();

		setCreateLenderLoading(true)
		axios.post(`${endpoint}/api/create-lender`, {
			name: lenderName
		}).then(() => {
			setLenderName("")
			fetchLendersList()
			setShowLenderModal(false)
			customToast.success("Lender created successfully!");
		}).catch((error) => {
			if (error.response) {
				customToast.error(error.response.data?.message);
			} else {
				customToast.error(error.message);
			}
		}).finally(() => {
			setCreateLenderLoading(false)
		})
	}, [lenderName, fetchLendersList]);

	// Update the Lender field
	const [editedIndex, setEditedIndex] = useState({
		row: -1,
		column: ""
	});

	const updateTheField = useCallback((e, id) => {
		const name = e.target.name;
		let value = e.target.value;

		if (["salaried", "self_employed", "business", "lender_status", "so_status"].includes(name)) {
			value = e.target.checked ? 1 : 0;
		}

		if (["apr_min", "apr_max"].includes(name)) {
			value = parseFloat(value);
		}

		axios.post(`${endpoint}/api/update-lender-data`, {
			lender_id: id,
			property: name,
			value: value
		}).then(() => {
			customToast.success("Lender updated successfully!");
		}).catch((error) => {
			if (error.response) {
				customToast.error(error.response.data?.message);
			} else {
				customToast.error(error.message);
			}
		}).finally(() => {
			setEditedIndex({
				row: -1,
				column: ''
			})
		})
	}, []);

	// Delete Lender
	const [deleteId, setDeleteId] = useState(-1);
	const [deleteLoading, setDeleteLoading] = useState(false);

	const deleteLender = useCallback(() => {
		setDeleteLoading(true)
		axios.post(`${endpoint}/api/safe-delete-lender`, {
			lender_id: deleteId
		}).then(() => {
			customToast.success("Lender deleted successfully!");
			setLenders((prev) => {
				return prev.filter(item => item.lender_id !== deleteId)
			})
			setDeleteId(-1);
		}).catch((error) => {
			if (error.response) {
				customToast.error(error.response.data?.message);
			} else {
				customToast.error(error.message);
			}
		}).finally(() => {
			setDeleteLoading(false)
		})
	}, [deleteId]);

	const handleEdit = useCallback((name, record) => {
		setEditName(name)
		setEditRecord({
			id: record.lender_id,
			...record
		})
	}, []);

	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("name");

	const handleSort = useCallback((key) => {
		setOrder(prevOrder => orderBy === key && prevOrder === "asc" ? "desc" : "asc");
		setOrderBy(key);
	}, [orderBy]);

	const [specialOffer, setSpecialOffer] = useState({
		offerText: "",
		startDate: "",
		endDate: ""
	})

	const handleSpecialOfferChange = useCallback((e) => {
		const { name, value } = e.target;
		setSpecialOffer((prev) => ({
			...prev,
			[name]: value,
		}));
	}, []);

	const [open, setOpen] = useState(false);

	const [selectedLender, setSelectedLender] = useState({})
	const [selectedLenderId, setSelectedLenderId] = useState(null)
	const [specialOfferLoading, setSpecialOfferLoading] = useState(false)

	const updateSpecialOffer = useCallback(async (field) => {
		setSpecialOfferLoading(true)
		const fieldsToUpdate = [
			{ property: "so_text", value: field.offerText },
			{ property: "so_date_start", value: field.startDate },
			{ property: "so_date_end", value: field.endDate },
		];

		const updatePromises = fieldsToUpdate.map(field =>
			axios.post(`${endpoint}/api/update-lender-data`, {
				lender_id: selectedLenderId,
				property: field.property,
				value: field.value
			})
		);

		try {
			await Promise.all(updatePromises);
			setLenders((prev) => {
				return prev.map((lender) => {
					if (lender.lender_id === selectedLenderId) {
						return { ...lender, so_text: field.offerText, so_date_start: field.startDate, so_date_end: field.endDate };
					}
					return lender;
				})
			})
			customToast.success("Lender updated successfully!");
			setSelectedLender(null)
			setSelectedLenderId(null)
			setOpen(false)
		} catch (error) {
			if (error.response) {
				customToast.error(error.response.data?.message);
			} else {
				customToast.error(error.message);
			}
		} finally {
			setSpecialOfferLoading(false)
		}
	}, [selectedLenderId]);

	// Memoize table headers rendering
	const renderTableHeaders = useMemo(() => (
		tableHeaders.map((header) => (
			<TableCell key={header.key}
				sx={{
					...stickyStyle,
					zIndex: 3,
					whiteSpace: 'nowrap'
				}}
			>
				{header.sortable ? (
					<TableSortLabel
						active={orderBy === header.key}
						direction={orderBy === header.key ? order : "asc"}
						onClick={() => handleSort(header.key)}
					>
						{header.label}
					</TableSortLabel>
				) : (
					header.label
				)}
			</TableCell>
		))
	), [orderBy, order, handleSort]);

	return <>
		<Helmet>
			<title>Admin - Lenders {app_title && `| ${app_title}`}</title>
		</Helmet>
		<Paper variant="outlined" sx={{ padding: 2 }}>
			<Box sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center'
			}}>
				<Typography variant="h6" color="secondary.main" mb={2}>Lenders</Typography>
				<Stack direction="row" spacing={1}>
					<Button
						variant='contained'
						onClick={() => {
							setShowLenderModal(true)
							setLenderName("")
						}}
					>
						Add Lender
					</Button>
				</Stack>
			</Box>

			{/* begin::Table Container */}
			<TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'border.main', maxHeight: '80vh', mt: 2 }}>
				{isLoading ? (
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
						<CircularProgress size={24} />
						<Typography sx={{ ml: 2 }}>Loading lenders data...</Typography>
					</Box>
				) : (
					<Table stickyHeader aria-label="simple table">
						<TableHead>
							<TableRow>
								{renderTableHeaders}
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{lenders.length === 0 ? (
								<TableRow>
									<TableCell colSpan={tableHeaders.length + 1} align="center">
										<Typography variant="body1" sx={{ py: 2 }}>No lenders found</Typography>
									</TableCell>
								</TableRow>
							) : (
								lenders.map((lender, idx) => (
									<LenderTableRow
										key={lender.lender_id || idx}
										lender={lender}
										idx={idx}
										editedIndex={editedIndex}
										setEditedIndex={setEditedIndex}
										handleInputChange={handleInputChange}
										updateTheField={updateTheField}
										ticketClass={ticketClass}
										creditScoreClass={creditScoreClass}
										setSelectedLender={setSelectedLender}
										setSelectedLenderId={setSelectedLenderId}
										setOpen={setOpen}
										setDeleteId={setDeleteId}
									/>
								))
							)}
						</TableBody>
					</Table>
				)}
			</TableContainer>
			{/* end::Table Container */}

			{/* begin::Delete confirmation popup */}
			<StyledModal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				open={deleteId !== -1}
				onClose={() => setDeleteId(-1)}
				closeAfterTransition
				slots={{ backdrop: StyledBackdrop }}
			>
				<Fade in={deleteId !== -1}>
					<Box sx={style}>
						<Typography align='center' variant="h6" color="secondary.main" mb={2}>Are you sure?</Typography>
						<Box sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 2,
						}}>
							<Button
								color="primary"
								variant="outlined"
								size="small"
								onClick={() => setDeleteId(-1)}
							>
								Cancel
							</Button>
							<LoadingButton
								loading={deleteLoading}
								color="error"
								variant="contained"
								size="small"
								onClick={deleteLender}
							>
								Delete
							</LoadingButton>
						</Box>
					</Box>
				</Fade>
			</StyledModal>
			{/* end::Delete confirmation popup */}

			{/* begin::Create lender modal */}
			<Dialog
				open={showLenderModal}
				scroll="paper"
				fullScreen={fullScreen}
				fullWidth
				TransitionComponent={Transition}
				component="form"
				autoComplete="off"
				sx={{
					zIndex: 9999
				}}
				onSubmit={createLender}
			>
				<DialogContent>
					<Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
						<Typography variant="h6" color="secondary.main">Add Lender</Typography>
						<IconButton onClick={() => setShowLenderModal(false)}>
							<CloseIcon />
						</IconButton>
					</Grid>
					<Grid container justifyContent="center" spacing={3}>
						<Grid item xs={12}>
							<TextField
								margin="dense"
								required
								fullWidth
								label={t("Name")}
								name="lenderName"
								value={lenderName}
								onChange={(e) => {
									if(!(e.target.value.match(/^[A-Za-z0-9_-]*$/))) return;
									setLenderName(e.target.value)
								}}
							>
							</TextField>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<LoadingButton
						loading={createLenderLoading}
						color="secondary"
						variant="contained"
						size="large"
						fullWidth
						type="submit"
					>
						{t("Submit")}
					</LoadingButton>
				</DialogActions>
			</Dialog>
			{/* end::Create lender modal */}
		</Paper>

		<CreditCardUpdateDialog
			open={!!editName}
			name={editName}
			type="number"
			record={editRecord}
			onClose={() => {
				setEditRecord({})
				setEditName(null)
			}}
			onSave={() => {
				fetchLendersList()
				setEditRecord({})
				setEditName(null)
			}}
			module={"lenders"}
		/>

		<SpecialOffersModal
			open={open}
			loading={specialOfferLoading}
			values={{
				offerText: selectedLender?.so_text || "",
				startDate: selectedLender?.so_date_start || "",
				endDate: selectedLender?.so_date_end || "",
			}}
			handleSave={updateSpecialOffer}
			onClose={() => {
				setSelectedLenderId(null)
				setSelectedLender(null)
				setOpen(false)
			}}
		/>
	</>
}

const StyledModal = styled(Modal)`
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = (theme) => ({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	borderRadius: '12px',
	padding: '16px 32px 24px 32px',
	backgroundColor: theme.palette.mode === 'dark' ? '#0A1929' : 'white',
	boxShadow: `0px 2px 24px ${theme.palette.mode === 'dark' ? '#000' : '#383838'}`,
});